/////////////////////////////////////////////////////////////////////////////////////////////////////////
// 화일명 : axiosSetup.ts
// 설명 : axios 전역 인터셉터(1회만 등록, index.tsx에서 import)
//  - 요청 : 세션쿠키(token, httpOnly)는 withCredentials로 브라우저가 알아서 실어 보냄 - 더 이상 JS에서
//           Authorization 헤더를 직접 붙이지 않음(2026-10-17, HTTPS 적용 후 localStorage+헤더 방식에서
//           httpOnly 쿠키로 전면 전환 - XSS로 토큰이 그대로 읽히는 구멍을 막기 위함).
//  - 요청 : 로그인 화면에서 고른 회사코드를 X-Co-Cd 헤더로 첨부(SaaS 멀티테넌시 - 백엔드가 그 회사 DB로 연결).
//  - 응답 : 401(쿠키 없음/만료/위조)이면 로그인 정보를 정리하고 로그인 화면으로 이동.
/////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios from 'axios';
import { clearUserInfo } from './userUtils';
import { getSelectedCoCd } from './companyUtil';

// 세션쿠키(token)/2차인증 "이 기기 기억" 쿠키(mfaDevice) 둘 다 크로스오리진(개발환경 기준 프론트:3000/백엔드:5000)에서도
// 주고받기 위함 - 서버 CORS의 credentials:true와 짝을 이룸.
axios.defaults.withCredentials = true;

axios.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  const coCd = getSelectedCoCd();
  if (coCd) (config.headers as any)['X-Co-Cd'] = coCd;   // 회사(SaaS 멀티테넌시)
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      // 중복로그인 허용=N인 계정이 다른 곳에서 새로 로그인해 이 세션이 종료된 경우 - 로그인 화면에서 안내하도록 메시지를 남김
      if (['Z90011', 'Z90012', 'Z90013', 'Z90014', 'Z90015', 'Z90018'].includes(error.response.data?.msgCd)) {   // Z90018 라이선스 만료/중지로 세션 종료   // Z90011 다른 곳 로그인 / Z90012 관리자 강제종료 / Z90013 라이선스 동시접속 한도로 밀려남 / Z90014 등록 안 된 회사 / Z90015 회사 정보 불일치
        try { sessionStorage.setItem('loginNotice', String(error.response.data?.msgText || '')); } catch { /* 저장 실패는 무시 */ }
      }
      localStorage.removeItem('tokenExpiresAt');
      clearUserInfo();
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);
